import React from 'react';
import { TextField, MenuItem, SxProps } from '@mui/material';
import { allServerNames, getFinalServerName } from '../data/servers';

interface ServerDropdownProps {
  value: string | undefined | null;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  sx?: SxProps;
  showAllServersOption?: boolean;
  name?: string;
}

const ServerDropdown: React.FC<ServerDropdownProps> = ({
  value,
  onChange,
  label = 'Server',
  disabled = false,
  required = false,
  fullWidth = false,
  sx,
  showAllServersOption = false,
  name = 'server'
}) => {
  return (
    <TextField
      select
      label={label}
      value={value || ''}
      onChange={(e) => {
        const selectedValue = e.target.value as string;
        onChange(selectedValue);
      }}
      disabled={disabled}
      required={required}
      fullWidth={fullWidth}
      sx={sx}
      name={name}
    >
      {showAllServersOption && (
        <MenuItem value="">All Servers</MenuItem>
      )}
      {allServerNames.map(serverName => {
        const finalServer = getFinalServerName(serverName);
        return (
          <MenuItem key={serverName} value={serverName}>
            {serverName}
            {finalServer !== serverName && (
              <span style={{ color: '#666' }}>&nbsp;&nbsp;({finalServer})</span>
            )}
          </MenuItem>
        );
      })}
    </TextField>
  );
};

export default ServerDropdown; 